const SHOWN_DIGITS = 5;
const MASK = '•••••';

export const maskPhone = (number: string): string | null => {
  const digits = number.replace(/\D/g, '');
  if (digits.length === 0) return null;
  if (digits.length <= SHOWN_DIGITS) return MASK;
  return `${MASK} ${digits.slice(-SHOWN_DIGITS)}`;
};
